import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import store from './store'
import { setHeader } from './helpers/setHeader'
import Tooltip from 'vue-directive-tooltip'
// import 'vue-directive-tooltip/cssindex.css'
Vue.use(Tooltip, {
  placement: 'right'
})
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  setHeader(`${store.getters.getTokenType} ${store.getters.getToken}`)
  if (to.matched.some(record => record.meta.protected) && !store.getters.isAuthenticated) {
    next('/auth/login')
  } else if (to.matched.some(record => record.meta.requiresAdminPermissions) && !store.getters.isAdmin) {
    next('/auth/login')
  } else {
    next()
  }
})

new Vue({
  store,
  render: h => h(App),
  router
}).$mount('#app')
